/**
 * Amplitude flag key for the "game launcher unified-module" experiment
 * (`game_launcher_um_enable` -> gameLauncherUMEnabled).
 */
export const GAME_LAUNCHER_UM_EXPERIMENT = 'game_launcher_um_enable';

/** Amplitude flag keys for the Canada net-position feature. */
export const NET_POSITION_ENABLED_EXPERIMENT = 'net_position_enabled';
export const NET_POSITION_FORCE_EXPERIMENT = 'net_position_force';
export const NET_POSITION_GAME_SWITCH_NOT_AVAILABLE_EXPERIMENT =
  'net_position_game_switch_not_available';

/**
 * Amplitude flag key for the in-game (FGP) wallet experiment.
 * Raw key from casino-game-launcher#2164 ExperimentsMap
 * (`casino-in-game-wallet-v2` -> `casinoInGameWalletV2Enabled`). Enabling variant: `'on'`.
 */
export const CASINO_IN_GAME_WALLET_EXPERIMENT = 'casino-in-game-wallet-v2';

/**
 * Amplitude flag key for the game-switch feature toggle. Ports casino-game-launcher's
 * ExperimentsMap entry (`game-switch-enable` -> `gameSwitchEnabled`, CAS-50883). Gates the
 * `GC/GAME_SWITCH` handling flow. Enabling variants: `'on'` / `'treatment'`.
 */
export const GAME_SWITCH_ENABLE_EXPERIMENT = 'game-switch-enable';

/**
 * Amplitude flag key for the casino-game-window-service (game-window-data) rollout
 * (CAS-68931). Enabling variants: `'on'` / `'treatment'`.
 */
export const USE_GAME_WINDOW_DATA_EXPERIMENT = 'use-game-window-data';

/**
 * Amplitude flag key for the in-game promo merch experiment. Ports casino-game-launcher's
 * ExperimentsMap entry (`in-game-merch` -> `inGameMerchEnabled`, CAS-62663). Amplitude lowercases
 * variant values. Any served variant other than `'control'` turns merch on and is passed to the
 * rewards orchestrator as its `abcKey` (`'ingamemerchfull'` / `'ingamemerchtoast'`).
 */
export const IN_GAME_MERCH_EXPERIMENT = 'in-game-merch';

/**
 * Reads a single experiment value out of the raw Amplitude variants stored in
 * the `amplitudeExperiments` slice. Amplitude's `experiment.all()` returns
 * `{ [flagKey]: { value, payload } }`, but defensively we also accept a bare
 * string variant. Returns `undefined` when the flag is absent or malformed.
 */
export const getExperimentValue = (
  experiments: Record<string, unknown> | null | undefined,
  key: string,
): string | undefined => {
  const variant = experiments?.[key];

  if (typeof variant === 'string') {
    return variant;
  }

  if (variant && typeof variant === 'object' && 'value' in variant) {
    const value = (variant as { value?: unknown }).value;
    return typeof value === 'string' ? value : undefined;
  }

  return undefined;
};
